'use strict';

angular.module('licensure.services')
    .factory('LicenseRequestSupplementalTrainingTrainings', ['$http', '$q', 'Trainings', 'Documents', 'Upload', function ($http, $q, Trainings, Documents, Upload) {
        var saveTraining = function (training, licenseRequestID) {
            var d = $q.defer();
            var promises = [];

            if (training.file_updated && training.file_content != null && training.file_name != null) {
                promises.push(Documents.upload({
                    file: Upload.dataUrltoBlob(training.file_content, training.file_name),
                    name: training.document_name
                }, licenseRequestID).then(function (document) {
                    if (document != null) {
                        training.document_id = document.id;
                        training.document_code = document.code;
                    }
                }))
            }

            $q.all(promises).then(function () {
                training.file_content = null;
                Trainings.save(training, licenseRequestID).then(function (savedTraining) {
                    d.resolve(savedTraining);
                });           
            }).catch(function (response) {
                // handle error
            });

            return d.promise;
        }

        var clearElement = function (licenseRequestID, trainingIDs) {
            var d = $q.defer();

            $http
                .post(apiLocation + '/api/LicenseRequestSupplementalTrainingTrainings/clearElement', {
                    license_request_id: licenseRequestID,
                    trainingIDs: trainingIDs
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/LicenseRequestSupplementalTrainingTrainings', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            saveElement: function (trainings, licenseRequestID) {
                var d = $q.defer();
                var promises = [];

                var savedTrainingIDs = null;

                trainings.forEach(function (training) {
                    if (training.training_location != null && (!isValidGuid(training.training_location.id) || !isValidGuid(training.training_location_id))) {
                        training.training_location = null;
                        training.training_location_id = null;
                    }
                    promises.push(saveTraining(training, licenseRequestID).then(function(savedTraining) {
                        if (savedTraining.id != null) {
                            if (savedTrainingIDs == null) {
                                savedTrainingIDs = savedTraining.id;
                            }
                            else {
                                savedTrainingIDs += ',' + savedTraining.id;
                            }
                        }
                    }));                    
                })

                $q.all(promises).then(function () {
                    clearElement(licenseRequestID, savedTrainingIDs).then(function () {
                        d.resolve();
                    })
                })                

                return d.promise;
            },

            logSupplementalDates: function (responseId, applicationTypeId, userId) {
                var d = $q.defer();

                var data = {
                    responseID: responseId,
                    applicationTypeID: applicationTypeId,
                    userID: userId
                };

                $http({
                    method: "POST",
                    url: apiLocation + "/api/EducationModule/LogSupplementalDates",
                    data: data
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },
        }
    }])
;